/* global $, jQuery, THEME_OBJ */

import CustomSwiper from "./components/custom-swiper";
import ControlledSwiper from "./components/controlled-swiper";
import FullScreenSlider from "./components/full-screen-slider";
import HalfSlider from "./components/half-slider";
import HotelCards from "./components/hotel-cards";
import MainSlider from "./components/main-slider";
import MegaSlider from "./components/mega-slider";
import ScrollAnimations from "./components/scrollAnimations";
import SliderWithTimer from "./components/slider-with-timer";
import Header from "./components/header";
import Tabs from "./components/tabs";
import { RestaurantFilters, CareersFilters } from "./components/filters";
import EnquiryForm from "./components/enquiry-form";
import PhotoGallery from "./components/photoswipe";
import AnchorLink from "./components/anchor-link";
import MenuToggle from "./components/menu-toggle";
import GoogleMap from "./components/google-map";
import Accordion from "./components/accordion";
import MapRoutes from "./components/map-routes";
import { calculateVH } from "./helpers";
import SplitTextEffect from "./components/split-text";
import AnimateUpEffect from "./components/animate-up";
import FadeInEffect from "./components/fade-in";
import AnimateBgEffect from "./components/animate-bg";
import FadeInUpEffect from "./components/fade-in-up";
import BtnOutlineEffect from "./components/btn-outline-effect";
import AnimateLeftEffect from "./components/animate-left";
import DragCursor from "./components/drag-cursor";
import ParallaxElements from "./components/parallax-elements";
import RevealEffect from "./components/reveal";
import BookingForm from "./components/booking-form";
import BookingPopup from './components/booking-popup';

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onReady
 * @return {void}
 */
const domReady = (onReady) => {
	if (document.readyState !== "loading") {
		// Document is already ready, call the callback directly
		onReady();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener("DOMContentLoaded", onReady);
	} else {
		// Old IE browsers
		document.attachEvent("onreadystatechange", function () {
			if (document.readyState === "complete") {
				onReady();
			}
		});
	}
};

const App = {
	init() {
		console.log(
			"\n\n%cCreated with %c♥ %cby Nelios%c\n\n",
			"border-top-left-radius: 10px;border-bottom-left-radius: 10px;padding: 20px 0px 20px 20px;color: #fff;background: #7cc142;",
			"padding: 20px 0px 20px 0px;background: #7cc142;color: red;",
			"border-top-right-radius: 10px;border-bottom-right-radius: 10px;padding: 20px 20px 20px 0px;background: #7cc142;color: #fff;",
			"background: white;"
		);

		const header = new Header();

		Array.from(document.querySelectorAll(".section-hero .swiper")).map(
			(el) => new CustomSwiper(el)
		);

		Array.from(
			document.querySelectorAll(".section-inline-slider-with-text .swiper")
		).map((el) => new CustomSwiper(el));

		Array.from(
			document.querySelectorAll(".section-slider-with-descriptive-text")
		).map((el) => new ControlledSwiper(el));

		Array.from(document.querySelectorAll(".section-large-gallery .swiper")).map(
			(el) => new CustomSwiper(el)
		);

		Array.from(
			document.querySelectorAll(".section-more-blog-posts .swiper")
		).map((el) => new CustomSwiper(el));

		Array.from(
			document.querySelectorAll(".section-accommodation-slider .swiper")
		).map((el) => new CustomSwiper(el));

		Array.from(document.querySelectorAll(".section-view-more .swiper")).map(
			(el) => new CustomSwiper(el)
		);

		Array.from(
			document.querySelectorAll(".section-square-carousel .swiper")
		).map((el) => new CustomSwiper(el));

		Array.from(
			document.querySelectorAll(".section-instagram-feed .swiper")
		).map((el) => new CustomSwiper(el));

		Array.from(
			document.querySelectorAll(".section-restaurants-list-placeholder .swiper")
		).map((el) => new CustomSwiper(el));

		const hotelCards = new HotelCards();

		Array.from(
			document.querySelectorAll(".section-text-with-half-slider .swiper")
		).map((el) => new HalfSlider(el));

		Array.from(document.querySelectorAll(".section-persons-list .swiper")).map(
			(el) => new HalfSlider(el)
		);

		Array.from(document.querySelectorAll(".section-mega-slider .swiper")).map(
			(el) => new HalfSlider(el)
		);

		Array.from(document.querySelectorAll(".section-main-slider .swiper")).map(
			(el) => new MainSlider(el)
		);

		Array.from(
			document.querySelectorAll(".section-full-screen-slider .swiper")
		).map((el) => new FullScreenSlider(el));

		Array.from(
			document.querySelectorAll(".section-slider-with-timer .swiper")
		).map((el) => new SliderWithTimer(el));

		Array.from(document.querySelectorAll(".section-mega-slider")).map(
			(el) => new MegaSlider(el)
		);

		Array.from(document.querySelectorAll("[data-smooth-scroll]")).map(
			(el) => new ScrollAnimations(el)
		);

		Array.from(document.querySelectorAll(".tabs")).map((tab) => new Tabs(tab));

		Array.from(
			document.querySelectorAll(
				".section-restaurants-list-placeholder .filters"
			)
		).map((filters) => new RestaurantFilters(filters));

		Array.from(
			document.querySelectorAll(".section-careers-list-placeholder .filters")
		).map((filters) => new CareersFilters(filters));

		Array.from(document.querySelectorAll(".enquiry-form")).map(
			(form) => new EnquiryForm(form)
		);

		Array.from(document.querySelectorAll(".application-form")).map(
			(form) => new EnquiryForm(form)
		);

		Array.from(document.querySelectorAll(".pswp-gallery")).map(
			(gallery) => new PhotoGallery(gallery)
		);

		Array.prototype.filter
			.call(
				document.querySelectorAll("a[href]"),
				(el) =>
					!el.getAttribute("href").startsWith("#tab") &&
					RegExp(/^#/).test(el.getAttribute("href"))
			)
			.map((link) => new AnchorLink(link));

		const toggle = new MenuToggle(document.getElementById("menu-toggle"));

		toggle.toggle.addEventListener("click", (event) => {
			mobileMenuTop.closeSubMenuNavLink();
			mobileMenuBottom.closeSubMenuNavLink();
		});

		if (document.getElementById("map")) {
			let gmap = new GoogleMap(document.getElementById("map").dataset.options);
		}

		Array.from(document.querySelectorAll("[data-map-route]")).map(
			(route) => new MapRoutes(route)
		);

		Array.from(document.querySelectorAll(".accordion")).map(
			(accordion) => new Accordion(accordion)
		);

		Array.from(document.querySelectorAll(".split-text")).map(
			(el) => new SplitTextEffect(el)
		);

		Array.from(document.querySelectorAll(".animate-up")).map(
			(el) => new AnimateUpEffect(el)
		);

		Array.from(document.querySelectorAll(".animate-left")).map(
			(el) => new AnimateLeftEffect(el)
		);

		Array.from(document.querySelectorAll(".animate-bg")).map(
			(el) => new AnimateBgEffect(el)
		);

		Array.from(document.querySelectorAll(".fade-in")).map(
			(el) => new FadeInEffect(el)
		);

		if (Array.from(document.querySelectorAll(".fade-in-up")).length) {
			new FadeInUpEffect();
		}

		if (Array.from(document.querySelectorAll(".reveal-effect")).length) {
			new RevealEffect();
		}

		if (Array.from(document.querySelectorAll(".btn-outline-light")).length) {
			new BtnOutlineEffect();
		}

		if (Array.from(document.querySelectorAll("[data-cursor]")).length) {
			new DragCursor();
		}

		window.addEventListener("resize", () => {
			calculateVH();
		});

		// setTimeout(() => {
		window.dispatchEvent(new Event("resize"));
		window.dispatchEvent(new Event("scroll"));
		// }, 2000);

		//Header submenus
		const subMenus = document.querySelectorAll(
			"#menu-primary-menu .menu-item, .menu-hotel .menu-item"
		);

		subMenus.forEach((el) => {
			const subMenuItem = el.querySelector(".sub-menu");
			if (subMenuItem) {
				el.addEventListener("mouseover", (e) => {
					subMenuItem.classList.add("active");
				});
				el.addEventListener("mouseout", (e) => {
					subMenuItem.classList.remove("active");
				});
			}
		});

		if (document.getElementById("hero-video-full")) {
			//If we have the fullscreen video,

			let normalVideo = document.getElementById("hero-video");
			let fullVideo = document.getElementById("hero-video-full");

			normalVideo.addEventListener("click", () => {
				normalVideo.pause();
				goFullscreen();
				fullVideo.classList.remove("hidden");
				fullVideo.play();
			});

			fullVideo.addEventListener("click", () => {
				// fullVideo.pause();
				leaveFullScreen();
				fullVideo.classList.add("hidden");
				normalVideo.play();
			});

			//Events to handle going in/out of fullscreen
			document.addEventListener("fullscreenchange", function () {
				if (!document.fullscreenElement) {
					//Exited from fullscreen
					fullVideo.classList.add("hidden");
					fullVideo.pause();
					normalVideo.play();
				}
			});
			document.addEventListener("webkitfullscreenchange", function () {
				if (!document.webkitFullscreenElement) {
					//Exited from fullscreen
					fullVideo.classList.add("hidden");
					fullVideo.pause();
					normalVideo.play();
				}
			});

			const goFullscreen = () => {
				if (fullVideo.requestFullscreen) {
					fullVideo.requestFullscreen();
				} else if (fullVideo.mozRequestFullScreen) {
					fullVideo.mozRequestFullScreen();
				} else if (fullVideo.webkitRequestFullScreen) {
					fullVideo.webkitRequestFullScreen();
				} else if (fullVideo.msRequestFullscreen) {
					fullVideo.msRequestFullscreen();
				}
			};

			const leaveFullScreen = () => {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
			};
		}

		if (document.querySelector(".js-read-more")) {
			const readMoreContainers = document.querySelectorAll(".js-read-more");
			readMoreContainers.forEach((c) => {
				const target = c.dataset.readMoreTarget;
				if (document.querySelector(`.${target}`)) {
					const scrollHeight = c.scrollHeight;
					let targetHeight = document.querySelector(`.${target}`).height;
					targetHeight = parseFloat(targetHeight) * 0.8;
					if (parseFloat(scrollHeight) * 0.9 <= parseFloat(targetHeight)) {
						c.classList.remove("closed");
						c.style.maxHeight = "none";
						document
							.querySelector(
								`[data-js-read-more-target=${c.dataset.readMoreButton}]`
							)
							.classList.remove("js-read-more-button");
						document.querySelector(
							`[data-js-read-more-target=${c.dataset.readMoreButton}]`
						).style.display = "none";
					} else {
						c.style.maxHeight = `${targetHeight}px`;
					}
				}
			});
			const readMoreButtons = document.querySelectorAll(".js-read-more-button");
			readMoreButtons.forEach((c) => {
				const target = c.dataset.jsReadMoreTarget;
				const btnSvg = c.querySelector("svg");
				if (document.querySelector(`.${target}`)) {
					c.addEventListener("click", function () {
						const targetEl = document.querySelector(`.${target}`);
						if (!btnSvg.classList.contains("up")) {
							btnSvg.classList.add("up");
							targetEl.setAttribute(
								"data-js-read-more-h",
								targetEl.offsetHeight
							);
							targetEl.style.maxHeight = `${targetEl.scrollHeight}px`;
							targetEl.classList.remove("closed");
						} else {
							btnSvg.classList.remove("up");
							targetEl.style.maxHeight = `${targetEl.dataset.jsReadMoreH}px`;
							targetEl.classList.add("closed");
						}
					});
				}
			});
		}

		if (document.querySelector(".section-newsletter")) {
			let toggleableContainers = document.querySelectorAll(
				".section-newsletter .toggleable"
			);
			let toggleableButtons = document.querySelectorAll(
				".section-newsletter .toggle-button"
			);

			toggleableContainers.forEach((container) => {
				let height = 300;
				container.style.position = "absolute";
				container.style.visibility = "hidden";
				container.style.display = "block";

				height = container.offsetHeight;

				// reverting to the original values
				container.style.position = "relative";
				container.style.visibility = "visible";
				container.style.height = "0px";
				container.setAttribute("data-container-height", height);
			});
			toggleableButtons.forEach((button) => {
				button.addEventListener("click", () => {
					let target = document.querySelector(
						`.section-newsletter .toggleable[data-toggle-id="${button.dataset.toggleTarget}"]`
					);
					button.style.display = "none";
					if (target) {
						if (target.style.height === "0px") {
							target.style.height = `${target.dataset.containerHeight}px`;
							setTimeout(() => {
								target.classList.remove("toggleable");
							}, 1000);
						} else {
							target.style.height = "0px";
						}
					}
				});
			});
		}

		if (
			document.getElementById("posts-load-more") ||
			document.getElementById("restaurants-load-more")
		) {
			//blog page js
			const loadMoreBtn = document.getElementById("posts-load-more")
				? document.getElementById("posts-load-more")
				: document.getElementById("restaurants-load-more");
			if (loadMoreBtn) {
				loadMoreBtn.addEventListener("click", () => {
					loadMoreBtn.classList.add("disabled");
					loadMoreBtn.querySelector(".label").style.display = "none";
					loadMoreBtn.querySelector(".loader").style.display = "block";

					let action = loadMoreBtn.dataset.action;
					let page = loadMoreBtn.dataset.page;

					if (document.getElementById("restaurants-load-more")) {
						//We need custom functionality for the restaurant list
						// console.log(parseInt(loadMoreBtn.dataset.countRestaurants));
						// console.log(parseInt(loadMoreBtn.dataset.loadedRestaurants));
						if (
							parseInt(loadMoreBtn.dataset.countRestaurants) <=
							parseInt(loadMoreBtn.dataset.loadedRestaurants)
						) {
							action = loadMoreBtn.dataset.actionBars;
							page = loadMoreBtn.dataset.barPage;
						}
					}

					// console.log("Executing action: " + action);
					// console.log("Page: " + page);

					const data = new FormData();
					data.append("action", action);
					data.append("nonce", loadMoreBtn.dataset.nonce);
					data.append("page", page);

					fetch(THEME_OBJ.ajax_url, {
						method: "POST",
						credentials: "same-origin",
						body: data,
					})
						.then((response) => response.json())
						.then((data) => {
							if (data) {
								document.querySelector(".posts-wrapper").innerHTML += data.html;

								if (document.getElementById("restaurants-load-more")) {
									if (action === loadMoreBtn.dataset.action) {
										loadMoreBtn.dataset.loadedRestaurants =
											parseInt(loadMoreBtn.dataset.loadedRestaurants) + 9;
										loadMoreBtn.setAttribute(
											"data-page",
											parseInt(loadMoreBtn.dataset.page) + 1
										);
									} else {
										loadMoreBtn.setAttribute(
											"data-barPage",
											parseInt(loadMoreBtn.dataset.barPage) + 1
										);
										loadMoreBtn.dataset.loadedBars =
											parseInt(loadMoreBtn.dataset.loadedBars) + 9;
									}

									if (
										(data.is_last === true &&
											parseInt(loadMoreBtn.dataset.loadedRestaurants) >=
												parseInt(loadMoreBtn.dataset.countRestaurants)) ||
										data.html === ""
									) {
										if (
											parseInt(loadMoreBtn.dataset.loadedBars) >=
											parseInt(loadMoreBtn.dataset.countBars)
										) {
											loadMoreBtn.style.display = "none";
										}
									}
								} else {
									if (data.is_last === true || data.html === "") {
										loadMoreBtn.style.display = "none";
									}
									loadMoreBtn.setAttribute(
										"data-page",
										parseInt(loadMoreBtn.dataset.page) + 1
									);
								}
							}

							loadMoreBtn.classList.remove("disabled");
							loadMoreBtn.querySelector(".label").style.display = "block";
							loadMoreBtn.querySelector(".loader").style.display = "none";
						})
						.catch((error) => {
							// console.log("[WP Nelios Ajax Load Posts]");
							console.error(error);

							loadMoreBtn.classList.remove("disabled");
							loadMoreBtn.querySelector(".label").style.display = "block";
							loadMoreBtn.querySelector(".loader").style.display = "none";
						});
				});
			}
		}

		if (document.querySelector(".section-instagram-feed")) {
			const slides = document.querySelectorAll(".swiper-slide");
			const backdrop_wrapper = document.querySelector(
				".section-instagram-feed .modal-holder"
			);
			backdrop_wrapper.addEventListener("click", (e) => {
				if (e.target !== e.currentTarget) return;
				const open_modal = backdrop_wrapper.getAttribute("open-modal");
				document
					.querySelector(
						`.section-instagram-feed .modal-holder .modal-${open_modal}`
					)
					.classList.add("hidden");
				backdrop_wrapper.classList.add("hidden");
			});

			const modal_close_buttons = document.querySelectorAll(
				".section-instagram-feed .modal-close"
			);
			modal_close_buttons.forEach((b) => {
				b.addEventListener("click", () => {
					const data_id = b.dataset.id ?? -1;
					if (data_id !== -1) {
						const backdrop = document.querySelector(
							".section-instagram-feed .modal-holder"
						);
						const modal = document.querySelector(
							`.section-instagram-feed .modal-holder .modal-${data_id}`
						);
						backdrop.classList.add("hidden");
						modal.classList.add("hidden");
					}
				});
			});

			slides.forEach((s) => {
				s.addEventListener("click", () => {
					const data_id = s.dataset.id ?? -1;
					if (data_id !== -1) {
						const backdrop = document.querySelector(
							".section-instagram-feed .modal-holder"
						);
						const modal = document.querySelector(
							`.section-instagram-feed .modal-holder .modal-${data_id}`
						);
						backdrop.classList.remove("hidden");
						backdrop.setAttribute("open-modal", data_id);
						modal.classList.remove("hidden");
					}
				});
			});
		}

		const mobileMenuTop = new MobileMenu("top");
		const mobileMenuBottom = new MobileMenu("bottom");

		const parallaxElement = new ParallaxElements();

		const sectionMap = document.querySelector(".section-map");
		const sectionForm = document.querySelector(".section-enquiry-form");
		sectionMap && sectionForm && sectionForm.append(sectionMap);

		// DO NOT DELETE BELLOW BEFORE GERMAN OR GREEK LANGUAGE GO LIVE
		if (window.location.href.indexOf("/el/") > -1) {
			var newMetaTag = document.createElement("meta");
			newMetaTag.name = "robots";
			newMetaTag.content = "noindex, nofollow";

			var headElement = document.head;

			var existingMetaTags = document.querySelectorAll('meta[name="robots"]');
			for (var i = 0; i < existingMetaTags.length; i++) {
				headElement.removeChild(existingMetaTags[i]);
			}

			headElement.appendChild(newMetaTag);
		}
		// DO NOT DELETE ABOVE BEFORE GERMAN OR GREEK LANGUAGE GO LIVE


		document.addEventListener('DOMContentLoaded', function() {
			const navbarTel = document.getElementById('navbar-tel');
			const popup = document.getElementById('popup-contact-details');
			const menu = document.getElementById('wrapper-navbar');
			function togglePopup(event) {
				event.preventDefault();
				event.stopPropagation();
				popup.classList.toggle('hidden');
				if (window.innerWidth <= 767) {
					if (popup.classList.contains('show')) {
						popup.classList.remove('show');
						popup.classList.add('hide');
						setTimeout(() => {
							popup.classList.remove('hide');
							popup.classList.add('hidden');
						}, 500);
					} else {
						popup.classList.remove('hidden');
						popup.classList.add('show');
					}

					menu.classList.add('has-sticky-header');
				}
			}
			function hidePopup(event) {
				if (!popup.classList.contains('hidden')) {
					popup.classList.add('hidden');
				}
				if (window.innerWidth <= 767) {
					if (popup.classList.contains('show')) {
						popup.classList.remove('show');
						popup.classList.add('hide');
						setTimeout(() => {
							popup.classList.remove('hide');
							popup.classList.add('hidden');
						}, 500);
					}
					menu.classList.remove('has-sticky-header');
				}
			}
			navbarTel && navbarTel.addEventListener("click", togglePopup);
			popup && popup.addEventListener("click", function(event) {
				event.stopPropagation();
			});
			popup && document.body.addEventListener("click", hidePopup);

			// function checkWindowWidth() {
			// 	togglePopup();
			// 	hidePopup();
			// }
			//
			// window.addEventListener("resize", checkWindowWidth);
			// checkWindowWidth();
		});

		// const openBookingPopupButton = document.querySelector('[data-id="open-booking-popup"]');
		// openBookingPopupButton.addEventListener('click', function() {
		// 	const bookingPopup = document.querySelector('[data-id="booking-popup"]');
		// 	bookingPopup.classList.remove('hidden');
		// 	bookingPopup.classList.add('flex');
		// });

		const bookingForm = new BookingForm();

		const bookingPopup = new BookingPopup();

	},
};

export default class MobileMenu {
	constructor(position) {
		if (!position) return;

		this.menuPosition = position;

		this.init();
		this.events();
	}

	init() {
		this.currentSubMenu;
		this.mobileNavLinks = document.querySelectorAll(
			".mobile-nav-link-" + this.menuPosition
		);

		if (this.mobileNavLinks) {
			this.mobileNavLinks.forEach((mobileNavLink) => {
				if (mobileNavLink.hasAttribute("id")) {
					const subMenu = this.getSubMenuByParentId(mobileNavLink.id);
					mobileNavLink.addEventListener("click", (event) => {
						event.preventDefault();
						this.openSubMenuNavLink(mobileNavLink, subMenu);
					});
				}
			});
		}

		this.mobileCloseSubMenuButton = document.querySelector(
			"#mobile-close-" + this.menuPosition + "-sub-menu-button"
		);
	}
	enableNavLinks() {
		//
		this.mobileNavLinks.forEach((currentNavLink) => {
			// currentNavLink.setAttribute("aria-expanded", false);
			currentNavLink.style.opacity = 1;
		});
	}
	disableNavLinks() {
		this.mobileNavLinks.forEach((currentNavLink) => {
			// currentNavLink.setAttribute("aria-expanded", true);
			currentNavLink.style.opacity = 0;
		});
	}

	openSubMenuNavLink(navLink, subMenu) {
		subMenu.classList.add("active");
		this.currentSubMenu = subMenu;
		this.mobileCloseSubMenuButton.style.display = "block";
		this.disableNavLinks();
	}

	closeSubMenuNavLink() {
		this.currentSubMenu.classList.remove("active");
		this.mobileCloseSubMenuButton.style.display = "none";
		this.enableNavLinks();
	}
	getSubMenuByParentId(parentId) {
		return document.querySelector("[aria-labelledby=" + parentId + "]");
	}

	events() {
		this.mobileCloseSubMenuButton &&
			this.mobileCloseSubMenuButton.addEventListener("click", (event) => {
				// currentNavLink.setAttribute("aria-expanded", false);
				this.closeSubMenuNavLink();
			});
	}
}

domReady(() => {
	App.init();
});
